import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=e970a100"
import script from "./MyProfile.vue?vue&type=script&lang=ts"
export * from "./MyProfile.vue?vue&type=script&lang=ts"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=e970a100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports